export default __webpack_public_path__ + "static/three_body_v2-1c2c6a4267bf053667dd7ca9161e47c7.png";